import { motion } from 'framer-motion';
import { Search, Moon, Sun } from 'lucide-react';
import { useThemeStore } from '../../stores/themeStore';
import { NotificationBell } from '../notifications/NotificationBell';

export function Header() {
  const { theme, toggleTheme } = useThemeStore();

  return (
    <header className="h-16 border-b border-border bg-bg/80 backdrop-blur-xl sticky top-0 z-20">
      <div className="h-full px-6 flex items-center justify-between">
        {/* Search */}
        <div className="flex-1 max-w-md">
          <motion.div
            whileFocus={{ scale: 1.02 }}
            className="relative"
          >
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-muted" />
            <input
              type="text"
              placeholder="Search..."
              className="w-full pl-10 pr-4 py-2 bg-bg-secondary border border-border rounded-xl
                         text-sm placeholder:text-text-muted
                         focus:outline-none focus:border-accent focus:ring-2 focus:ring-accent/20
                         transition-all"
            />
          </motion.div>
        </div>

        {/* Right actions */}
        <div className="flex items-center gap-2">
          {/* Theme toggle */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={toggleTheme}
            className="relative p-2.5 rounded-xl hover:bg-bg-secondary transition-colors overflow-hidden"
          >
            <motion.div
              initial={false}
              animate={{
                rotate: theme === 'dark' ? 0 : 180,
                scale: theme === 'dark' ? 1 : 0,
              }}
              transition={{ type: 'spring', stiffness: 200 }}
              className="absolute inset-0 flex items-center justify-center"
            >
              <Moon className="w-5 h-5" />
            </motion.div>
            <motion.div
              initial={false}
              animate={{
                rotate: theme === 'light' ? 0 : -180,
                scale: theme === 'light' ? 1 : 0,
              }}
              transition={{ type: 'spring', stiffness: 200 }}
              className="flex items-center justify-center"
            >
              <Sun className="w-5 h-5" />
            </motion.div>
          </motion.button>

          {/* Notifications */}
          <NotificationBell />
        </div>
      </div>
    </header>
  );
}
